import { getDataRuleTenantList } from '@/common/services';
import ZlbConfirm from '@/components/ZlbConfirm';
import { reqDetail } from '@/routes/AcrossUnit/services';
import { notification } from 'doraemon';
import { reqReimburseType } from 'src/services/user';
import {
  budgetReimburseRelation,
  cancelOrgMatch,
  changeStatus,
  checkEmptyProcess,
  copyProcessModel,
  fetchBudgetList,
  getInstitutionMember,
  getInstitutionMemberDesensitization,
  getTagCombineList,
  getTenantInstitutionTree,
  importExcelCommit,
  importExcelResult,
  newProcessModel,
  pageProcess,
  pageProcessModel,
  queryBudgetSceneByBudgetId,
  queryCostControlRule,
} from '../services/unitManage';

const responseErrorHandle = res => {
  const { success, message } = res;
  if (!success) {
    ZlbConfirm({
      title: message,
      showOkBtn: false,
      cancelText: '知道了',
    });
  }
};

export default {
  namespace: 'zoningUnitManage',
  state: {
    tableQueryParams: {},
    reimburseTypeList: [],
    unitDetail: {},
    actionType: 'add',
    userInfo: {},
    tableInfo: {
      data: [],
      page: 0,
      size: 0,
      total: 0,
      totalPage: 0,
    },
    expandedKeysList: null,
    defaultSelectedKeys: [],
    dataRuleTenantList: [],
  },
  effects: {
    // 获取有权限的租户列表
    *getDataRuleTenantList({ payload }, { call, put }) {
      const result = yield call(getDataRuleTenantList, payload);
      yield put({
        type: 'update',
        payload: {
          dataRuleTenantList: result?.tenants || [],
        },
      });
    },
    /**
     * 报销场景列表
     */
    *getReimburseType({ payload }, { call, put }) {
      const res = yield call(reqReimburseType, payload);
      yield put({
        type: 'update',
        payload: {
          reimburseTypeList: res.result || [],
        },
      });
    },
    /**
     * 预算指标列表（分页）
     */
    *fetchBudgetIndicatorsList({ payload }, { call, put }) {
      const res = yield call(fetchBudgetList, payload);
      responseErrorHandle(res);
      return res;
    },
    /**
     * 预算指标与报销场景关联
     */
    *budgetReimburseRelation({ payload }, { call, put }) {
      const res = yield call(budgetReimburseRelation, payload);
      responseErrorHandle(res);
      return res;
    },
    /**
     * 根据预算id查询预算报销场景
     */
    *queryBudgetSceneByBudgetId({ payload }, { call, put }) {
      const res = yield call(queryBudgetSceneByBudgetId, payload);
      responseErrorHandle(res);
      return res;
    },
    // 流程类型名称模糊搜索
    *pageProcess({ payload }, { call }) {
      const res = yield call(pageProcess, payload);
      responseErrorHandle(res);
      return res?.result?.data || [];
    },
    // 新增流程
    *newProcessModel({ payload }, { call }) {
      const res = yield call(newProcessModel, payload);
      return res || {};
    },
    // 复制流程
    *copyProcessModel({ payload }, { call }) {
      const res = yield call(copyProcessModel, payload);
      return res || {};
    },
    // 机构详情
    *getUnitDetail({ payload }, { call, put }) {
      const res = yield call(reqDetail, payload);
      responseErrorHandle(res);
      yield put({
        type: 'update',
        payload: {
          unitDetail: res.result,
        },
      });
      return res;
    },
    // 流程分页列表
    *pageProcessModel({ payload }, { call, put }) {
      const res = yield call(pageProcessModel, payload);
      responseErrorHandle(res);
      return res;
    },
    // 校验空流程
    *checkEmptyProcess({ payload }, { call }) {
      const res = yield call(checkEmptyProcess, payload);
      responseErrorHandle(res);
      return res || {};
    },
    // 上、下架流程
    *changeStatus({ payload }, { call }) {
      const res = yield call(changeStatus, payload);
      responseErrorHandle(res);
      return res || {};
    },
    // 费控规则
    *getCostControlRule({ payload }, { call }) {
      const res = yield call(queryCostControlRule, payload);
      responseErrorHandle(res);
      return res || {};
    },

    *getInstitutionMember({ payload }, { call, put }) {
      try {
        const res = yield call(getInstitutionMember, payload);
        yield put({
          type: 'update',
          payload: {
            tableInfo: res.result || {},
          },
        });
      } catch (e) {
        notification.error({
          message: '部门人员获取失败',
        });
        throw e;
      }
    },

    // 脱敏
    *getInstitutionMemberDesensitization({ payload }, { call, put }) {
      try {
        const res = yield call(getInstitutionMemberDesensitization, payload);
        yield put({
          type: 'update',
          payload: {
            tableInfo: res.result || {},
          },
        });
      } catch (e) {
        notification.error({
          message: '部门人员获取失败',
        });
        throw e;
      }
    },
    // 删除预算单位匹配关系
    *deleteOrgMatch({ payload }, { call, put }) {
      const res = yield call(cancelOrgMatch, payload);
      responseErrorHandle(res);
      return res;
    },

    // 标签联合查询
    *getTagCombineList({ payload }, { call }) {
      const res = yield call(getTagCombineList, payload);
      responseErrorHandle(res);
      return res || {};
    },

    // 批量导入人员操作-提交
    *importExcelCommit({ payload }, { call }) {
      const res = yield call(importExcelCommit, payload);
      responseErrorHandle(res);
      return res;
    },

    // 批量导入人员操作-查询
    *importExcelResult({ payload }, { call }) {
      const { serialCode } = payload || {};
      const res = yield call(importExcelResult, serialCode);
      responseErrorHandle(res);
      return res;
    },

    // 查询部门树-租户平台使用
    *getTenantInstitutionTree({ payload }, { call }) {
      const res = yield call(getTenantInstitutionTree, payload);
      return res;
    },
  },
  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
